import { bundleIcon, DismissFilled, DismissRegular } from "@fluentui/react-icons";
import React from "react";
import { IconButton } from "./IconButton";

type Props = {
  isSelected?: boolean;
  disabled?: boolean;
  onClick?: () => void;
};

const CombinedIcon = bundleIcon(DismissFilled, DismissRegular);

export const DismissButton: React.FC<Props> = (props) => {
  return <IconButton {...props} icon={<CombinedIcon />} />;
};
